export default {
  TITLE_DOSE_NOT_EXIST: "عنوان وارد نشده است.",
  TITLE_INVALID: "عنوان نامعتبر است.",

  PRICE_DOSE_NOT_EXIST: "مبلغ وارد نشده است.",
  PRICE_INVALID: "مبلغ نامعتبر است.",

  AMOUNT_DOSE_NOT_EXIST: "درصد وارد نشده است.",
  AMOUNT_INVALID: "درصد نامعتبر است.",

  AMOUNT_MIN_PRICE_CATEGORY_USER_SITE_PUBLISHER_DOSE_NOT_EXIST:
    " حداقل مبلغ گروه نمایش دهنده برای تخفیف وارد نشده است.",
  AMOUNT_MIN_PRICE_CATEGORY_USER_SITE_PUBLISHER_INVALID:
    "حداقل مبلغ گروه نمایش دهنده برای تخفیف نامعتبر است.",

  AMOUNT_MIN_DAYS_COUNT_CATEGORY_USER_SITE_PUBLISHER_DOSE_NOT_EXIST:
    "حداقل تعداد روز نمایش برای تخفیف وارد نشده است.",
  AMOUNT_MIN_DAYS_COUNT_CATEGORY_USER_SITE_PUBLISHER_INVALID:
    "حداقل تعداد روز نمایش برای تخفیف نامعتبر است.",

  START_DATE_DISCOUNT_DOSE_NOT_EXIST:
    "تاریخ و ساعت شروع استفاده از کد تخفیف وارد نشده است.",
  START_DATE_DISCOUNT_INVALID:
    "تاریخ و ساعت شروع استفاده از کد تخفیف نامعتبر است.",

  END_DATE_DISCOUNT_DOSE_NOT_EXIST:
    "تاریخ و ساعت پایان استفاده از کد تخفیف وارد نشده است.",
  END_DATE_DISCOUNT_INVALID:
    "تاریخ و ساعت پایان استفاده از کد تخفیف نامعتبر است.",

  MAX_COUNT_USE_DISCOUNT_DOSE_NOT_EXIST:
    "محدودیت بیشترین استفاده کد تخفیف وارد نشده است.",
  MAX_COUNT_USE_DISCOUNT_INVALID:
    "محدودیت بیشترین استفاده کد تخفیف نامعتبر است.",

  MAX_COUNT_USE_VIA_USERS_DOSE_NOT_EXIST:
    "محدودیت بیشترین استفاده کد تخفیف برای هر کاربر وارد نشده است.",
  MAX_COUNT_USE_VIA_USERS_INVALID:
    "محدودیت بیشترین استفاده کد تخفیف برای هر کاربر نامعتبر است.",

  WHICH_USERS_CAN_USE_DISCOUNT_DOSE_NOT_EXIST:
    "کاربران استفاده کننده  وارد نشده است.",
  WHICH_USERS_CAN_USE_DISCOUNT_INVALID: "کاربران استفاده کننده  نامعتبر است.",

  AMOUNT_DISCOUNT_POSITION_BANNER_INVALID: "عدد تخفیف وارد شده اشتباه است.",

  START_DATE_IS_PAST_FROM_CURRENT_DATE: "تاریخ شروع از تاریخ جاری قبل تر است.",
  END_DATE_IS_PAST_FROM_START_DATE: "تاریخ پایان از تاریخ شروع قبل تر است.",
};
